const PROFILE_ID_MAX_LENGTH = 24;

export const buildProfileIdCandidates = (name: string): string[] => {
  const ascii = name
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
  const words = ascii
    .split(/[^a-z0-9]+/)
    .map((word) => word.trim())
    .filter((word) => word.length > 0);
  if (words.length === 0) return [];

  const truncate = (value: string) => value.slice(0, PROFILE_ID_MAX_LENGTH);
  const acronym = words.map((word) => word[0]).join("");
  const firstWord = words[0];
  const firstTwoWords = words.slice(0, 2).join("");
  const fullJoined = words.join("");
  const shouldUseAcronymFirst = words.length >= 3 && acronym.length >= 3;

  return Array.from(
    new Set(
      [
        ...(shouldUseAcronymFirst ? [acronym] : []),
        ...(words.length === 2
          ? [firstTwoWords, firstWord, fullJoined]
          : [firstWord, firstTwoWords, fullJoined]),
      ].map(truncate)
    )
  );
};

export const buildProfileIdPreview = (name: string): string =>
  buildProfileIdCandidates(name)[0] || "";
